import {
  Context,
  createContext,
  default as React,
  useContext,
  useState,
} from 'react';

export interface IDialogContext {
  open: (dialog: string) => void;
  close: (dialog: string) => void;
  contexts: Record<string, any>;
  setContext: (dialog: string, newData: any) => void;
}

export const DialogsContext: Context<IDialogContext> = createContext({} as any);

export default DialogsContext;
export const useDialogsContext = (): IDialogContext =>
  useContext(DialogsContext);

export function DialogsProvider({ children, ...dialogs }) {
  const [state, setState] = useState(dialogs);
  const [contexts, setContexts] = useState({});

  function close(dialog) {
    setState({ ...state, [dialog]: false });
  }

  function open(dialog) {
    setState({ ...state, [dialog]: true });
  }

  function setContext(dialog, newData) {
    setContexts({ ...contexts, [dialog]: newData });
  }

  return (
    <DialogsContext.Provider
      value={{
        open,
        close,
        contexts,
        setContext,
        ...state,
      }}
    >
      {children}
    </DialogsContext.Provider>
  );
}
